module.exports = __webpack_public_path__ + "img/312.b55f0e38.png";